export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_APP_ERROR = 'SET_APP_ERROR';
export const SET_APP_ACTION = 'SET_APP_ACTION';

export const setAppLoading =
    (status = false, message = '') =>
    (dispatch) => {
        dispatch({ type: SET_APP_LOADING, loading: { status, message } });
    };

export const setAppError =
    (status = false, message = '') =>
    (dispatch) => {
        dispatch({ type: SET_APP_ERROR, error: { status, message } });
    };

export const setAppAction =
    (status = false, message = '') =>
    (dispatch) => {
        dispatch({ type: SET_APP_ACTION, action: { status, message } });
    };

export default {
    setAppLoading,
    setAppError,
    setAppAction,
    SET_APP_ACTION,
    SET_APP_ERROR,
    SET_APP_LOADING,
};
